import { render, staticRenderFns } from "./tel-returnc-case-manage.vue?vue&type=template&id=1cdfd396&scoped=true"
import script from "./tel-returnc-case-manage.vue?vue&type=script&lang=ts"
export * from "./tel-returnc-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdfd396",
  null
  
)

export default component.exports